import { WORKSPACE_SSO_ENFORCED_REASON } from "@ark/shared";

import { extractGraphQLErrorReasonList } from "./extract-graphql-error-reason-list";

export function isWorkspaceSsoEnforcedError(error: unknown): boolean {
  return extractGraphQLErrorReasonList(error).includes(WORKSPACE_SSO_ENFORCED_REASON);
}
